export default __webpack_public_path__ + "static/media/binance.73971de3.webp";